import type { PrescribedMedicationResponseSchema } from '@montugroup/prescription-contracts';
import type { PrescriptionHistoryStatePreviousItem } from '../types';

/**
 * Maps the initial previously prescribed medications' prescriptionStatus and reissueStatus to the prescription history state type.
 * @param prescribedMedications - A list of prescribed medications from `prescribed-medications` endpoint.
 * @returns A list of previous items with the prescription status and reissue status.
 */
export const mapPrescribedMedicationsToPreviousItems = (
  prescribedMedications: PrescribedMedicationResponseSchema['prescribedMedications']
): PrescriptionHistoryStatePreviousItem[] =>
  prescribedMedications.map((prescribedMedication) => ({
    id: prescribedMedication.id,
    prescriptionStatus: prescribedMedication.status,
    reissueStatus: {
      productId: prescribedMedication.id,
      isReissued: true,
      isOutOfStock: prescribedMedication.reissue.linkAttributes?.isOutOfStock,
      isDiscontinued: prescribedMedication.reissue.linkAttributes?.isDiscontinued,
      isActive: prescribedMedication.reissue.linkAttributes?.isActive,
      productName: prescribedMedication.product.productName,
      supplierName: prescribedMedication.product.supplierName,
      description: prescribedMedication.product.description,
      isUnavailable: prescribedMedication.reissue.linkAttributes?.isUnavailable,
      createdDate: prescribedMedication.dossier[0].createdDate
    },
    prescriptionDetails: {
      dosage: prescribedMedication.dossier[0].dosage,
      quantity: prescribedMedication.dossier[0].quantity,
      repeats: prescribedMedication.dossier[0].repeats,
      interval: prescribedMedication.dossier[0].interval
    }
  }));
